import { Location } from '@core/Router/locations';
import { lazy } from 'react';

const AttachmentStatusPage = lazy(() =>
    import(/* webpackChunkName: "attachment" */ '../ui/AttachmentStatusPage').then(m => ({
        default: m.AttachmentStatusPage,
    })),
);

export const attachmentLocations: Location[] = [
    {
        url: '/attachment',
        Component: AttachmentStatusPage,
    },
];
